export default "__VITE_ASSET__Bdy0vz9K__"